import Background from 'Components/Reusable/Background/Background';
import React, { Fragment, useState, useEffect } from 'react';
import yourDetailsLogo from 'Assets/img/svg/logos/yourDetailsLogo.svg';
import { ReusableInput } from 'Components/Reusable/Inputs/ReusableInput';
import CustomCheckBox from 'Components/CheckBox/CustomCheckBox';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import { useStyles } from './yourDetails.style';
import { useFormik } from 'formik';
import * as yup from 'yup';
import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import CustomModal from 'Components/Modals/CustomModal';

import { conditions } from 'Utils/options';

import { GetProfile, GetAddress } from 'ReduxStore/profile/Action';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { billingAndShippingUpdate } from 'ReduxStore/profile/Action';
import { RootState } from 'ReduxStore/store';
import { Routes } from 'Utils/Route';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Link } from 'react-router-dom';

import ClipLoader from 'react-spinners/ClipLoader';
import Floating from 'Components/Shapes/Floating';
import big from 'Assets/img/svg/circles/big.svg';
import small from 'Assets/img/svg/circles/small.svg';
interface State {
	fullName: string;
	SAddress: string;
	SCity: string;
	SState: string;
	SzipCode: string;
	sphoneNumber: string;
	address: '';
	city: '';
	state: '';
	zipCode: '';
	phoneNumber: '';
}

const YourDetails = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const user = useSelector((state: RootState) => state.profile.user);
	const [state, setState] = useState(() => user && user?.isSameAddress);
	const [loading, setLoading] = useState(true);

	// user.isSameAddress ? setState(true) : setState(false)
	useEffect(() => {
		dispatch(GetProfile());
		const getAddress = async () => await GetAddress()(dispatch);
		getAddress();
	}, []);
	const childName = localStorage.getItem('currentChild');
	const address = useSelector((state: RootState) => state.profile.address);
	const validationSchema = yup.object({
		fullName: yup.string(),
		// before shipping address
		address: address?.address ? yup.string() : yup.string().required('Address is required'),
		city: address?.city ? yup.string() : yup.string().required('City is required'),
		state: address?.state ? yup.string() : yup.string().required('State is required'),
		zipCode: address?.zipCode ? yup.string() : yup.string().required('Zip code is required'),
		phoneNumber: address?.phoneNumber
			? yup.string()
			: yup
					.string()
					.required('Phone number is required')
					.length(10, 'Invalid phone number. Please try again'),

		// shipping address selected
		SAddress:
			state && !address?.shipping_address ? yup.string().required('Address is required') : yup.string(),
		SCity: state && !address?.shipping_city ? yup.string().required('City is required') : yup.string(),
		SState: state && !address?.shipping_state ? yup.string().required('State is required') : yup.string(),
		SzipCode:
			state && !address?.shipping_zipCode ? yup.string().required('Zip code is required') : yup.string(),
		sphoneNumber:
			state && !address?.shipping_phoneNumber
				? yup
						.string()
						.required('Phone number is required')
						.length(10, 'Invalid phone number. Please try again')
				: yup.string(),
	});
	const matches = useMediaQuery('(max-width:440px)');
	const [open, setOpen] = React.useState(false);

	const formik = useFormik({
		initialValues: {
			fullName: '',
			SAddress: '',
			SCity: '',
			SState: '',
			SzipCode: '',
			sphoneNumber: '',
			address: '',
			city: '',
			state: '',
			zipCode: '',
			phoneNumber: '',
		},
		validationSchema: validationSchema,
		onSubmit: values => {
			setLoading(address?.loading);
			const isSameAddress = state;
			dispatch(
				billingAndShippingUpdate({
					...values,
					address: values.address || address?.address,
					city: values.city || address?.city,
					state: values.state || address?.state,
					zipCode: values.zipCode || address?.zipCode,
					phoneNumber: values.phoneNumber || address?.phoneNumber,
					shipping_address: values.SAddress || address?.shipping_address,
					shipping_state: values.SState || address?.shipping_state,
					shipping_city: values.SCity || address?.shipping_city,
					shipping_zipCode: values.SzipCode || address?.shipping_zipCode,
					shipping_phoneNumber: values.sphoneNumber || address?.shipping_phoneNumber,
					isSameAddress,
					fullName: values.fullName || user?.fullName,
				}),
			);
			// todo - refactor to remove the bug incase the request fails
			setTimeout(() => {
				history.push(Routes.Menu);
			}, 2000);
		},
	});

	const yourElements = [
		{
			id: 1,
			name: 'fullName',
			value: 'fullName',
			type: 'text',
			placeholder: '',
			label: 'Full Name',
			defaultValue: user?.fullName,
		},
	];
	const shippingDetails = [
		{
			id: 1,
			name: 'address',
			type: 'text',
			placeholder: '',
			label: 'Address',
			defaultValue: address?.address,
		},
		{
			id: 2,
			name: 'city',
			label: 'City',
			value: 'SCity',
			type: 'text',
			placeholder: '',
			defaultValue: address?.city,
		},
		{
			id: 3,
			name: 'state',
			type: 'text',
			placeholder: '',
			label: 'State',
			defaultValue: address?.state,
		},

		{
			id: 4,
			name: 'zipCode',
			label: 'Zip Code',
			value: 'SzipCode',
			type: 'text',
			placeholder: '',
			defaultValue: address?.zipCode,
		},
		{
			id: 5,
			name: 'phoneNumber',
			label: 'Phone Number',
			value: 'SphoneNumber',
			type: 'text',
			placeholder: '',
			defaultValue: address?.phoneNumber,
		},
	];

	const billingDetails = [
		{
			id: 1,
			name: 'SAddress',
			type: 'text',
			value: 'BAddress',
			label: 'Address',
			placeholder: '',
			defaultValue: address?.shipping_address,
		},
		{
			id: 2,
			name: 'SCity',
			label: 'City',
			value: 'BCity',
			type: 'text',
			placeholder: '',
			defaultValue: address?.shipping_city,
		},
		{
			id: 3,
			name: 'SState',
			value: 'BState',
			label: 'State',
			type: 'text',
			placeholder: '',
			defaultValue: address?.shipping_state,
		},

		{
			id: 4,
			name: 'SzipCode',
			label: 'Zip Code',
			value: 'BzipCode',
			type: 'text',
			placeholder: '',
			defaultValue: address?.shipping_zipCode,
		},
		{
			id: 5,
			name: 'sphoneNumber',
			label: 'Phone Number',
			value: 'BphoneNumber',
			type: 'text',
			placeholder: '',
			defaultValue: address?.shipping_phoneNumber,
		},
	];

	const history = useHistory();

	const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
		event.preventDefault();

		setState(!state);
	};
	const handleOpen = () => {
		setOpen(true);
	};
	const handleModalClick = (condition: string) =>
		condition === 'yes' ? history.push(Routes.RestPassword) : setOpen(false);

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Fragment>
			<div className={classes.mobileBackground}>
				<div className={classes.membershipName}>
					<Link
						className={classes.links}
						style={{ color: matches ? '#0d6efd' : 'white' }}
						to={Routes.AddDetails}
					>
						{childName}&apos;s membership
					</Link>
				</div>
				<Floating big={big} small={small} />
			</div>
			<Background middleItem={yourDetailsLogo} height={state ? 'auto' : '100vh'} row>
				<div className={`${classes.background} mx-auto`}>
					<div className={classes.childBackground}>
						<ul className={`${classes.listItems} mb-3`}>
							<h6 className={`${classes.text} text-center py-2`}>Your Details</h6>
							{user
								? yourElements.map(element => (
										<li key={element.id} className="mt-2">
											<ReusableInput
												name={element?.name}
												type={element.type}
												label={element.label}
												placeholder={element.defaultValue}
												formik={formik}
												width="381.87px"
												height="53.91px"
												defaultValue={element.defaultValue}
											/>
											<p className="text-center my-3">Email: {user.email}</p>
										</li>
								  ))
								: ''}
						</ul>
						<div className="mx-auto d-flex mb-5">
							<CommonButton
								onClick={handleOpen}
								common={{
									width: '261px',
									height: '48px',
									background: '#FF7552',
									radius: '200px',
									margin: '0 auto',
									fontSize: '18px',
								}}
								command="Reset Password"
							/>
						</div>
					</div>

					<div className={classes.childBackground}>
						<form onSubmit={formik.handleSubmit}>
							<ul className={`${classes.listItems} text-center`}>
								<h6 className={`${classes.text} text-center py-2`}>Billing Address</h6>
								{shippingDetails.map(element => (
									<li key={element.id} className="mt-2">
										<ReusableInput
											name={element.name}
											type={element.type}
											placeholder={element.defaultValue}
											formik={formik}
											label={element.label}
											width="381.87px"
											height="53.91px"
											defaultValue={element.defaultValue}
										/>
									</li>
								))}
							</ul>

							<CustomCheckBox
								mainText="Billing and shipping address are different"
								handleChangeCheckbox={handleChangeCheckbox}
								checked={state}
							/>

							{state && (
								<div>
									<ul className={`${classes.listItems} text-center`}>
										<h6 className={`${classes.text} text-center py-2`}>Shipping Address</h6>
										{billingDetails.map(element => (
											<li key={element.id} className="mt-2">
												<ReusableInput
													name={element.name}
													type={element.type}
													placeholder={element.defaultValue}
													defaultValue={element.defaultValue}
													formik={formik}
													label={element.label}
													width="381.87px"
													height="53.91px"
												/>
											</li>
										))}
									</ul>
								</div>
							)}
							<div className="d-flex align-items-center justify-content-center">
								{' '}
								<CommonButton
									common={{
										width: '381.87px',
										height: '48px',
										background: '#7FD6DD',
										radius: '200px',
										fontSize: '24px',
									}}
									command={loading ? 'SAVE' : <ClipLoader color={'white'} loading={true} size={30} />}
								/>
							</div>
						</form>
					</div>
				</div>
				{open === true ? (
					<CustomModal open={open} handleClose={handleClose}>
						<ConditionalCard
							information="Eek! Are you sure you want to change your password? "
							heading={`Woah, Nelly!`}
							conditions={conditions}
							onClick={handleModalClick}
						/>
					</CustomModal>
				) : (
					''
				)}
			</Background>
		</Fragment>
	);
};

export default YourDetails;
